const Backbone = require('backbone');
require('store/global/pages/products/_call_to_action.dust');
require('jquery-mask-plugin');
const { sendCSRFHeader } = require('common/csrf_token');
const gtmHelper = require('lib/helpers/gtm_helper');

var CallToActionView = Backbone.View.extend({
	initialize: function() {
		$('#quote-form')
			.find('input.phone')
			.mask('(000)000-0000');
	},

	events: {
		'click .js-get-quote': '_getQuote',
		'click .js-submit-form': '_submitForm'
	},

	el: '.js-call-to-action',
	_submitForm: function(e) {
		e.preventDefault();
		var $formElement = $('#quote-form');
		if (this._validateForm($formElement)) {
			const formData = {
				productUniqueId: $('input#uniqueId').val(),
				siteId: window.dataLayer.siteId,
				customerEmail: $('input#entry_2010049518').val(),
				customerFullName: $('input#entry_935312255').val(),
				customerPhone: $('input#entry_15463690').val(),
				note: $('textarea#entry_682181163').val(),
				url: window.location.href
			};

			$.ajax({
				url: '/app/api/quote/request',
				data: formData,
				type: 'POST',
				dataType: 'json',
				beforeSend: function(xhr, settings) {
					sendCSRFHeader(xhr, settings);
					$formElement.find(':input').attr('disabled', 'true');
				},
				error: function() {
					$formElement
						.find('ul.notification')
						.addClass('alert-danger')
						.html('<li>Failed to send request, please try again later.</li>');
				},
				success: function() {
					$formElement
						.find('ul.notification')
						.addClass('alert-success')
						.html('<li>Thank you for your request. <br/> A representative will be in contact with you within 24 hours.</li>');
					$formElement.find(':input').val('');
				},
				complete: function() {
					$formElement.find(':input').attr('disabled', 'false');
				}
			});
		}
	},
	_validateForm: function($formElement) {
		var isValid = true;
		$formElement.find('input[required="true"]').each(function(index, elem) {
			var $elem = $(elem);
			if (!$.trim(String($elem.val()))) {
				$elem
					.parent()
					.find('.error-message')
					.text(' This field is required');
				isValid = false;
			} else {
				$elem
					.parent()
					.find('.error-message')
					.text('');
			}
		});

		// validate email
		var $emailElem = $('.email-input');

		if (!$.trim(String($emailElem.val()))) {
			$emailElem
				.parent()
				.find('.error-message')
				.text(' This field is required');
			isValid = false;
		} else if ($emailElem.val() && !this._isValidEmail($emailElem.val())) {
			$emailElem
				.parent()
				.find('.error-message')
				.text(' Invalid Email');
			isValid = false;
		} else {
			$emailElem
				.parent()
				.find('.error-message')
				.text('');
		}

		return isValid;
	},
	_isValidEmail: function(email) {
		return window.BCOM.util.validator.isValidEmail(email);
	},
	_getQuote: function(e) {
		e.preventDefault();
		var data = {
			linkName: `productPage:getQuote:${window.dataLayer.productId}`
		};

		gtmHelper.fireEvent({
			event: 'generic-click-tracking',
			linkName: data.linkName
		});

		Backbone.trigger('track:link', data);
	}
});

module.exports = CallToActionView;
